import React from 'react';
import PropTypes from 'prop-types';

import BoxWithTwoSections from 'components/BoxWithTwoSections';

import { clientDetails as TEXT } from 'locales/en/client';

const ClientDetails = ({ client }) => {
  const {
    integration,
    company,
    defaultRole,
    defaultFeeStructure,
    homepageUrl,
    loginUrl,
    tosUrl,
    landingPageUrl,
    disputeEmails,
    adminButtonColor,
    adminButtonText,
    adminButtonTextColor
  } = client;

  return (
    <div className="-mt-5 w-full">
      <BoxWithTwoSections
        textObject={TEXT}
        data={{
          left: {
            integration,
            company,
            disputeEmails,
            defaultRole,
            defaultFeeStructure,
          },
          right: {
            homepageUrl,
            loginUrl,
            tosUrl,
            landingPageUrl,
            ...(adminButtonColor && { adminButtonColor }),
            ...(adminButtonTextColor && { adminButtonTextColor }),
            ...(adminButtonText && { adminButtonText }),
          },
        }}
      />
    </div>
  );
};

ClientDetails.propTypes = {
  client: PropTypes.shape({}),
};
ClientDetails.defaultProps = {
  client: {},
};

export default ClientDetails;
